import React from 'react';
import styles from './dateLine.module.scss';
import classNames from 'classnames/bind';

const cx = classNames.bind(styles);

interface Props {
  displayDate: string;
}

export const DateLine = ({ displayDate }: Props) => {
  return (
    <div className={cx('dateLine')}>
      <div className={cx('divider')} />
      <div className={cx('dateBox')}>{displayDate}</div>
      <div className={cx('divider')} />
    </div>
  );
};
